<div
  #mainSize
  class="email-preview-main">
  <mat-tab-group
    mat-align-tabs="center"
    class="preview"
    (selectedTabChange)="changeOfTab($event.index)">
    <!-- LAPTOP View -->
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="material-icons">laptop</span>
      </ng-template>
      <ng-template matTabContent>
        <div
          class="email-preview-content"
          [ngStyle]="{ 'max-height': 'calc(100vh - ' + maxHeight + 'px)' }">
          @if (zoomValues['laptop']) {
            <div
              #laptopSize
              class="email-preview-laptop"
              [ngStyle]="{ zoom: zoomValues['laptop'] }">
              <app-basic-email
                #emailPreviewRoot
                [content]="emailContentHtml"></app-basic-email>
            </div>
          }
        </div>
      </ng-template>
    </mat-tab>

    <!-- MOBILE View -->
    <mat-tab>
      <ng-template mat-tab-label><span class="material-icons">phone_iphone</span></ng-template>
      <ng-template matTabContent>
        <div
          class="email-preview-content"
          [ngStyle]="{ 'max-height': 'calc(100vh - ' + maxHeight + 'px)' }">
          @if (zoomValues['mobile']) {
            <div
              #mobileSize
              class="email-preview-mobile"
              [ngStyle]="{ zoom: zoomValues['mobile'] }">
              <app-basic-email
                #emailPreviewRoot
                [content]="emailContentHtml"></app-basic-email>
            </div>
          }
        </div>
      </ng-template>
    </mat-tab>

    <!-- DESKTOP View -->
    <mat-tab>
      <ng-template mat-tab-label><span class="material-icons">desktop_windows</span></ng-template>
      <ng-template matTabContent>
        <div
          class="email-preview-content"
          [ngStyle]="{ 'max-height': 'calc(100vh - ' + maxHeight + 'px)' }">
          @if (zoomValues['desktop']) {
            <div
              #desktopSize
              class="email-preview-desktop"
              [ngClass]="{ 'preview-frame': frame, 'mat-elevation-z4': frame }"
              [ngStyle]="{ zoom: zoomValues['desktop'], 'max-width': 1200 + 'px' }">
              <app-basic-email
                #emailPreviewRoot
                [content]="emailContentHtml"></app-basic-email>
            </div>
          }
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
